<template>
  <v-form v-model="isValid">
    <v-row no-gutters>
      <v-col cols="12">
        <v-text-field dense class="col" v-model="formData.email" label="Email"
                      :rules="[rules.nonEmpty(formData.email, 'Email'), rules.validEmail(formData.email)]" required/>
      </v-col>
      <v-col cols="12" v-if="editPasswordFlag">
        <v-text-field
          dense
          class="col"
          label="New password"
          v-model="formData.password"
          :type="showPass ? 'text' : 'password'"
          :rules="passwordRules"
          :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPass = !showPass"
          @keyup.enter.native="submit"
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" class="text-left">
        <v-btn class="primary" @click="editPasswordFlag = true" v-if="!editPasswordFlag">Edit password</v-btn>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn class="default" @click="cancel()">Cancel</v-btn>
        <v-btn class="ml-3 success" @click="save()" :disabled="!isValid">Save</v-btn>
      </v-col>
    </v-row>
    <v-overlay :value="submitting" :absolute="true">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-form>
</template>

<script>
  import {nonEmptyField, validPassword, validEmail} from "../../helpers/helpers";

  export default {
    name: "loginUserForm",
    props: ['userData'],
    data: () => {
      return {
        showPass: false,
        formData: {
          email: '',
          password: '',
        },
        isValid: false,
        submitting: false,
        rules: {
          nonEmpty: nonEmptyField,
          validEmail: validEmail
        },
        passwordRules: [v => nonEmptyField(v, 'password'), v => validPassword(v)],
        editPasswordFlag: false,
      }
    },
    mounted() {
      this.formData = JSON.parse(JSON.stringify(this.userData));
    },
    computed: {},
    methods: {
      cancel() {
        this.$emit('cancel', null);
      },
      save() {
        if (this.isValid) {
          const payload = {
            clientId: this.userData.clientId,
            email: this.formData.email,
            userId: this.userData._id,
          }
          if (this.formData.password) {
            payload.password = this.formData.password;
          }

          this.submitting = true;
          this.$store.dispatch('updateLoginCredentials', payload)
            .then(success => {
              this.submitting = false;
              if (success) {
                this.cancel();
              }
            })
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Forms/loginUserForm.vue